import { FC } from "react";

import { useSettingsApi } from "../../../api/settingsApi";
import { useAssociationsInfoContext, useLocationContext } from "../../../contexts/editableItemContext";
import { useUserContext } from "../../../contexts/userContext";
import { LocationBranch } from "../../../models";
import style from "./style.module.scss";
import { ToggleButton } from "./toggle";
import { Props } from "./types";

export const Branches: FC<Props> = ({ locationMarketer, readOnly }) => {
	const { useSettingsQuery } = useSettingsApi();
	const { locationId } = useLocationContext();
	const { user } = useUserContext();
	const { data: settings } = useSettingsQuery(user?.userId, locationId);
	const { limitMarketerAssociations } = settings ?? {};
	const { filters, updateBranch } = useAssociationsInfoContext();

	const { marketerId, marketerEnabled, branches } = locationMarketer;
	const { stateId, name } = filters;
	const nameFilter = name?.trim()?.toLowerCase();

	return (
		<div className={style.list}>
			{branches
				.filter(({ branchStateId, branchName }) => {
					const stateMatches = !stateId || branchStateId == stateId;
					const nameMatches = !nameFilter || branchName.toLowerCase().includes(nameFilter);
					return stateMatches && nameMatches;
				})
				.map((b) => (
					<Branch key={b.branchId} {...b} />
				))}
		</div>
	);

	function Branch({ branchId, branchName, branchStateName, branchEnabled }: LocationBranch) {
		const buttonDisabled = limitMarketerAssociations ? !marketerEnabled : marketerEnabled;
		const enabled = limitMarketerAssociations ? branchEnabled : branchEnabled && !marketerEnabled;

		return (
			<div className={enabled ? style.branchRowEnabled : style.branchRow}>
				<ToggleButton
					enabled={branchEnabled}
					disabled={buttonDisabled || readOnly}
					update={(u) => updateBranch(marketerId, branchId, u)}
				/>
				<span className={style.branchName}>
					{branchName} ({branchStateName})
				</span>
			</div>
		);
	}
};
